import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { LocalCombustivel } from "../shared/local.model";
import { UtilService } from "../../../shared/services/util.service";
import { CombustivelApiService } from "../../combustiveis/shared/combustivel-api.service";
import { Combustivel } from "../../combustiveis/shared/combustivel.model";

@Component({
    selector: 'app-local-combustivel-form',
    template: require('./local-combustivel-form.component.html')
})
export class LocalCombustivelFormComponent implements OnInit {
    @Input() list: any[] = [];

    combustiveisList: Combustivel[] = [];

    constructor(
        private _combustivelApiService: CombustivelApiService,
        private _utilService: UtilService,
        private _route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.getCombustiveis();
    }

    clickAddNew() {
        let newItem: any = {
            ativo: true,
            combustivel: this.combustiveisList[0]
        };

        this.list.push(newItem);
    }

    keyupCurrency(item: any, i: number) {
        let valor: number = this._utilService.currencyFormat(item.preco, false);
        if (valor) {
            this.list[i].preco = valor;
        }
    }

    private getCombustiveis() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Combustivel[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.combustiveisList = list;

                if (!this.list.length) {
                    this.clickAddNew();
                }
                this.setListBind();

            }
        }.bind(this));

        this._combustivelApiService.onGetAll(onDone);
    }

    private setListBind() {
        let x = 0, lenX = this.list.length,
            y = 0, lenY = this.combustiveisList.length;

        for (x, lenX; x < lenX; x++) {
            let valor: number = this._utilService.currencyFormat(this.list[x].preco, true);
            if (valor) {
                this.list[x].preco = valor;
            }

            for (y = 0, lenY = this.combustiveisList.length; y < lenY; y++) {
                if (this.list[x].combustivelId === this.combustiveisList[y].id) {
                   this.list[x].combustivel = this.combustiveisList[y];
                   break;
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/local-combustivel-form/local-combustivel-form.component.ts
 **/